<template>
<div class="page">
      <!-- 1. Верхняя навигационная панель -->
      <v-card flat color="white" class="px-6 py-3 d-flex align-center justify-space-between border-b" style="border-bottom: 1px solid #e0e0e0;">
        <div class="d-flex align-center">
          <v-btn icon small class="mr-2" @click="$router.push('/diagnostic')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <div class="d-flex align-center">
            <v-avatar color="#009E60" size="32" class="mr-2">
              <v-icon color="white" small>mdi-domain</v-icon>
            </v-avatar>
            <span class="font-weight-bold grey--text text--darken-3 mr-1">Админка УД</span>
          </div>
          <span class="text-caption grey--text ml-2 d-none d-sm-block">Управление компетенциями, кейсами, пресетами ролей и модулями отчёта</span>
        </div>
        <v-btn outlined color="grey darken-2" small class="text-capitalize">
          <v-icon left small>mdi-refresh</v-icon> Сбросить всё
        </v-btn>
      </v-card>
      <div class="px-6 py-4">
        <v-tabs
          v-model="tab"
          background-color="transparent"
          color="#483CB9"
          slider-color="transparent"
          class="custom-tabs"
        >
          <v-tab
            v-for="(tabItem, i) in tabs"
            :key="i"
            class="rounded-lg text-capitalize font-weight-medium mr-3 tab-pill"
            style="min-width: auto; padding: 0 16px; height: 36px; border: 1px solid transparent;"
          >
            <v-icon small class="mr-2" v-if="tabItem.icon">{{ tabItem.icon }}</v-icon>
            {{ tabItem.label }}
          </v-tab>
        </v-tabs>
      </div>
      <v-tabs-items v-model="tab" class="transparent">
        <v-tab-item v-for="(t, ind) in tabs" :key="ind" >
          <component :is="t.component" v-bind="t.props || {}" />
        </v-tab-item>
      </v-tabs-items>
  <CompetenciesModal
    :value="competenciesModal"
    @input="SET_COMPETENCIES_MODAL"
  />
  <CompetencyEditModal
    v-model="competencyEditModal.show"
    :competency="currentCompetency"
    :loading="currentCompetencyLoading"
    @back="onBack"
    @save="saveCompetence"
  />
  <PresetEditModal
    v-model="presetEditModal.show"
    :preset="currentPreset"
    :loading="currentPresetLoading"
    @save="savePreset"
  />
  <CaseEditModal
    v-model="caseEditModal.show"
    :case-item="currentCase"
    :loading="currentCaseLoading"
    @save="saveCase"
  />
  <NoteEditModal
    v-model="noteEditModal.show"
    :note="currentNote"
    :loading="currentNoteLoading"
    @save="saveNote"
  />

  <StatusModal
    :show="notification.show"
    :success="notification.success"
    :message="notification.message"
    @update:show="SET_NOTIFICATION({ show: $event, success: notification.success, message: notification.message })"
  />

</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import LibraryCompetences from '../../components/Diagnostics/Admin/libraryCompetencies.vue';
import LibraryCases from '../../components/Diagnostics/Admin/LibraryCases.vue';
import LibraryNotes from '../../components/Diagnostics/Admin/LibraryNotes.vue';
import PresetsRoles from '../../components/Diagnostics/Admin/PresetsRoles.vue';
import CompetenciesModal from '../../components/Diagnostics/Modal/CompetenciesModal.vue';
import CompetencyEditModal from '../../components/Diagnostics/Modal/CompetencyEditModal.vue';
import PresetEditModal from '../../components/Diagnostics/Modal/presetEditModal.vue';
import CaseEditModal from '../../components/Diagnostics/Modal/CaseEditModal.vue';
import NoteEditModal from '../../components/Diagnostics/Modal/NoteEditModal.vue';
import StatusModal from '../../components/common/StatusModal.vue';

export default {
  name: 'AdminDiagnostic',
  components: {
    PresetEditModal,
    CompetencyEditModal,
    CompetenciesModal,
    PresetsRoles,
    LibraryCompetences,
    LibraryCases,
    LibraryNotes,
    CaseEditModal,
    NoteEditModal,
    StatusModal,
  },
  computed: {
    ...mapGetters({
      competenciesModal: 'diagnostics/diagnotics/competenciesModal',
      competencyEditModal: 'diagnostics/diagnotics/competencyEditModal',
      currentCompetency: 'diagnostics/diagnotics/currentCompetency',
      currentCompetencyLoading: 'diagnostics/diagnotics/currentCompetencyLoading',

      presetEditModal: 'diagnostics/diagnotics/presetEditModal',
      currentPreset: 'diagnostics/diagnotics/currentPreset',
      currentPresetLoading: 'diagnostics/diagnotics/currentPresetLoading',

      caseEditModal: 'diagnostics/diagnotics/caseEditModal',
      currentCase: 'diagnostics/diagnotics/currentCase',
      currentCaseLoading: 'diagnostics/diagnotics/currentCaseLoading',

      noteEditModal: 'diagnostics/diagnotics/noteEditModal',
      currentNote: 'diagnostics/diagnotics/currentNote',
      currentNoteLoading: 'diagnostics/diagnotics/currentNoteLoading',

      notification: 'diagnostics/diagnotics/notification',
    }),
  },
  methods: {
    ...mapMutations({
      SET_COMPETENCIES_MODAL: 'diagnostics/diagnotics/SET_COMPETENCIES_MODAL',
      SET_COMPETENCY_SHOW_MODAL: 'diagnostics/diagnotics/SET_COMPETENCY_SHOW_MODAL',

      SET_PRESET_SHOW_MODAL: 'diagnostics/diagnotics/SET_PRESET_SHOW_MODAL',
      SET_CURRENT_PRESET_LOADING: 'diagnostics/diagnotics/SET_CURRENT_PRESET_LOADING',

      SET_NOTIFICATION: 'diagnostics/diagnotics/SET_NOTIFICATION',
    }),
    ...mapActions({
      loadPresets: 'diagnostics/diagnotics/loadPresetsRoles',
      loadCompetencies: 'diagnostics/diagnotics/loadCompetenciesLibrary',
      loadCases: 'diagnostics/diagnotics/loadCasesLibrary',
      loadNotes: 'diagnostics/diagnotics/loadNotesLibrary',
      createNoteTemplate: 'diagnostics/diagnotics/createNoteTemplate',
      updateNoteTemplate: 'diagnostics/diagnotics/updateNoteTemplate',
      createPreset: 'diagnostics/diagnotics/createPreset',
      updatePreset: 'diagnostics/diagnotics/updatePreset',
      createCompetence: 'diagnostics/diagnotics/createCompetency',
      updateCompetence: 'diagnostics/diagnotics/updateCompetency',
      createCaseTemplate: 'diagnostics/diagnotics/createCaseTemplate',
      updateCaseTemplate: 'diagnostics/diagnotics/updateCaseTemplate',
    }),
    onBack() {
      this.SET_COMPETENCY_SHOW_MODAL(false);
      this.SET_COMPETENCIES_MODAL(true);
    },

    async saveCompetence(data) {
      const payload = {
        name: data.name,
        description: data.description,
        category: data.category,
        levels: data.levels,
        indicators: data.indicators,
        order: 0,
      };
      if (this.competencyEditModal.id) {
        await this.updateCompetence(payload);
      } else {
        await this.createCompetence(payload);
      }
    },

    async saveCase(data) {
      const payload = {
        competence: data.competence,
        name: data.name,
        description: data.description || '',
        order: 0,
      };
      if (this.caseEditModal.id) {
        await this.updateCaseTemplate(payload);
      } else {
        await this.createCaseTemplate(payload);
      }
    },

    async saveNote(data) {
      const payload = { kind: data.kind, text: data.text, assignment: data.assignment };
      if (this.noteEditModal.id) {
        await this.updateNoteTemplate(payload);
      } else {
        await this.createNoteTemplate(payload);
      }
    },

    async savePreset(data) {
      const payload = {
        name: data.name,
        description: data.description,
        competences: data.competences.map(c => (typeof c === 'object' ? c.id : c)),
        order: 0,
        is_active: true,
      };
      if (this.presetEditModal.id) {
        await this.updatePreset(payload);
      } else {
        await this.createPreset(payload);
      }
    }

  },
  data: () => ({
    tab: 0,
    tabs: [
      {
        label: 'Компетенции',
        icon: 'mdi-card-text-outline',
        component: LibraryCompetences
      },
      {
        label: 'Кейсы',
        icon: 'mdi-folder-open-outline',
        component: LibraryCases
      },
      { label: 'Пресеты ролей', icon: 'mdi-account-multiple-outline', component: PresetsRoles },
      { label: 'Шаблоны заметок', icon: 'mdi-note-text-outline', component: LibraryNotes },
      // { label: 'Модули отчёта', icon: 'mdi-file-document-box-outline' },
    ],
  }),
  async mounted() {
    await this.loadCompetencies();
    await Promise.all([this.loadPresets(), this.loadCases(), this.loadNotes()]);
  }
};
</script>

<style lang="scss">
/* Переменные цветов */
$primary-green: #009E60;
$primary-purple: #483CB9;
$border-color: #e0e0e0;

.v-application {
  .custom-tabs {
    .v-tab {
      background-color: #f0f0f0;
      border-radius: 6px;
      color: #666;
      transition: all 0.2s;

      &:hover {
        background-color: #e8e8e8;
      }

      &.v-tab--active {
        background-color: white;
        border: 1px solid $border-color;
        color: #333;
        font-weight: 600;
        box-shadow: 0 1px 2px rgba(0,0,0,0.05);
      }
    }

    .v-tabs-bar {
      background-color: transparent !important;
    }
    .v-tabs-slider-wrapper {
      display: none;
    }
  }

  .v-card {
    &.fill-height {
      height: 100%;
    }

    &.item:hover {
      border-color: $primary-purple !important;
      box-shadow: 0 4px 12px rgba(72, 60, 185, 0.08) !important;
    }
  }

  .v-chip {
    &.v-chip--label {
      background-color: #f5f5f5;
      color: $primary-purple;
    }
  }
}
</style>
